import React, { useState } from 'react';
import Select, { MultiValue } from 'react-select';
import {useAdminContext} from "../../contexts/AdminContext"

interface Option {
  value: string;
  label: string;
}

interface ComboBoxBoatCodeMultipleProps {
    setSelectedBoatCodes: (code:string[]) => void;
}


const ComboBoxBoatCode: React.FC<ComboBoxBoatCodeMultipleProps> = ({setSelectedBoatCodes}) => {

  const {tabIdBoats} = useAdminContext();

  const options = Object.entries(tabIdBoats).map(([boatId, boatInfo]) => {
    return {value: boatId, label: boatInfo.code};
  }).sort((a:Option, b:Option) => a.label.localeCompare(b.label));

  const initialOptions: Option[] = [];

  /** 
  if(tabIdUser2Boat){
    for(let key of tabIdUser2Boat[userId]){
        initialOptions.push({value: key, label: tabIdBoats[key].code});
    }
  }
  */
 
  const [selectedOptions, setSelectedOptions] = useState<MultiValue<Option>>(initialOptions);

  const handleChange = (selected: MultiValue<Option>) => {
    console.log(selected)
    let res = selected.map(elt => {
      return elt.label
    })
    console.log(res)
    setSelectedBoatCodes(res)
    setSelectedOptions(selected);
    
  };

  return (
    <div className="align-items-center g-3">
        <Select
            options={options}
            value={selectedOptions}
            onChange={handleChange}
            isMulti 
            placeholder="Séléctionner bateau(x) ..."
            className="mb-3"
        />
    </div>
  );
};

export default ComboBoxBoatCode;
